import ChiliPiperDS_FormHelpers from "./FormHelpers";
import ChiliPiperDS_EmailVerification from "./EmailVerification";
import ChiliPiperDS_PhoneVerification from "./PhoneVerification";
import ChiliPiperDS_Multistep from "./Multistep";
import ChiliPiperDS_Events from "./Events";
import ChiliPiperDS_DispatchEvents from "./DispatchEvents";

var ChiliPiperDS = new Object();

ChiliPiperDS.version = "1.0.0";
ChiliPiperDS.count = 1; // for testing
ChiliPiperDS.env = null;

ChiliPiperDS.$el = null;
ChiliPiperDS.formEl = null;
ChiliPiperDS.formId = null;
ChiliPiperDS.portalId = null;
ChiliPiperDS.formFallback = true; // form_fallback="false" attr disables the HS form modal entirely

ChiliPiperDS.accountName = null;
ChiliPiperDS.router = null;
ChiliPiperDS.meetingType = null;
ChiliPiperDS.submitTrigger = null; // submit_trigger attr — CP in-app trigger (e.g. "InAppButton")
ChiliPiperDS.adp4 = null; // adp4 attr — attribution, mapped to SF Additonal_Datapoint_4__c

ChiliPiperDS.formSettings = function ($el) {
  ChiliPiperDS.env = $el.attr("data-env");
  ChiliPiperDS.portalId =
    ChiliPiperDS.env === "staging" ? "50989089" : "23623022";
  ChiliPiperDS.formId = $el.attr("data-form-id");
  ChiliPiperDS.formFallback = $el.attr("data-form-fallback") !== "false"; // default on

  if ($el[0].hasAttribute("data-form-id") && helpers.shouldDebug("ds3"))
    console.log(`[ChiliPiperDS] Custom Form: ${ChiliPiperDS.formId}`);
};

ChiliPiperDS.routerSettings = function ($el) {
  ChiliPiperDS.accountName = $el[0].hasAttribute("data-appName")
    ? $el.attr("data-appName")
    : ChiliPiperDS.env === "staging"
      ? "thryv-sandbox"
      : "thryv";
  ChiliPiperDS.router = $el[0].hasAttribute("data-router")
    ? $el.attr("data-router")
    : "copy-of-global-demo-conversion-inbound-a";
  ChiliPiperDS.meetingType = $el[0].hasAttribute("data-MeetingType")
    ? $el.attr("data-MeetingType")
    : null;
  ChiliPiperDS.submitTrigger = $el[0].hasAttribute("data-submit-trigger")
    ? $el.attr("data-submit-trigger")
    : null;
  ChiliPiperDS.adp4 = $el[0].hasAttribute("data-adp4")
    ? $el.attr("data-adp4")
    : null;

  if (helpers.shouldDebug("ds3")) {
    console.log(`[ChiliPiperDS] Concierge Flow: ${this.router}`);
    console.log(`[ChiliPiperDS] Meeting Type: ${this.meetingType}`);
    console.log(`[ChiliPiperDS] Submit Trigger: ${this.submitTrigger}`);
  }
};

ChiliPiperDS.ready = function ($el) {
  if (helpers.shouldDebug("ds3"))
    console.log("[ChiliPiperDS] ready", this.count++);
  this.$el = $el;

  if (helpers.shouldDebug("ds3")) console.log("[ChiliPiperDS] init", $el);

  this.formSettings($el);

  this.routerSettings($el);

  this.initForm($el);

  ChiliPiperDS_Events.listen($el);

  this.maybeAutoOpen($el);
};

/**
 * Deep-link auto-open (open_param="…" on the shortcode): when the URL
 * carries the configured param set to "1", skip the HS form entirely and
 * open the Chili Piper scheduler directly via ChiliPiper.submit() with the
 * lead built from URL params — the product's trial flow already created the
 * contact and validated these details at signup. Replaces Qualified's
 * native ?q_showExperience deep link. The template only outputs
 * data-open-param when the shortcode says scheduler="chilipiper", so the
 * scheduler attr in page content is the cutover switch.
 *
 * Strict on "1" (not mere presence) so ?show_scheduler=0 is an explicit
 * "don't open" — matches the holding-page notice check on schedule-your-demo.
 *
 * Falls back to opening the form modal when the URL has no email (CP can't
 * route without one) or when CP errors/can't route the lead.
 */
ChiliPiperDS.maybeAutoOpen = function ($el) {
  var _this = ChiliPiperDS;

  if (!$el[0].hasAttribute("data-open-param")) return;

  var paramName = $el.attr("data-open-param");
  var urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get(paramName) !== "1") return;

  var email = urlParams.get("email");

  if (!email) {
    _this.openModalFallback($el, "no email param");

    return;
  }

  // concierge.js loads as a separate script (and can be delayed by the
  // JS optimizer) — poll for it before deciding, modal as last resort.
  var attempts = 0;
  var waitForCp = setInterval(function () {
    if (typeof ChiliPiper === "object") {
      clearInterval(waitForCp);
      _this.directSubmit(urlParams);

      return;
    }

    if (++attempts >= 40) // ~10s
    {
      clearInterval(waitForCp);
      _this.openModalFallback($el, "ChiliPiper never loaded");
    }
  }, 250);
};

/**
 * Open the CP scheduler via the flow's prescribed in-app trigger shape
 * (trigger + PersonEmail-keyed lead; flows configured with an in-app
 * trigger reject ThirdPartyForm). Shared by the deep link (email from the
 * URL param) and the fallback HS form (email the visitor submitted).
 * Instance attrs are respected: app_name/env -> accountName, router,
 * submit_trigger -> trigger, adp4 -> Additonal_Datapoint_4__c ("Additonal"
 * is the real SF API spelling).
 */
ChiliPiperDS.triggerSubmit = function (trigger, email, onError) {
  var _this = ChiliPiperDS;

  var lead = { PersonEmail: email };

  if (_this.adp4) lead.Additonal_Datapoint_4__c = _this.adp4;

  if (helpers.shouldDebug("ds3"))
    console.log(
      "[ChiliPiperDS] triggerSubmit — trigger " + trigger,
      _this.accountName,
      _this.router,
      lead,
    );

  ChiliPiper.submit(_this.accountName, _this.router, {
    trigger: trigger,
    lead: lead,
    onError:
      onError ||
      function () {
        console.warn("[ChiliPiperDS] triggerSubmit could not route");
      },
  });
};

/**
 * Open the CP scheduler straight from URL-param lead data — no HS form.
 * Field keys match what onBeforeSubmit sends in the form flow so routing
 * rules see the same shape.
 */
ChiliPiperDS.directSubmit = function (urlParams) {
  var _this = ChiliPiperDS;

  var onError = function () {
    console.warn(
      "[ChiliPiperDS] directSubmit could not route — falling back to the form modal",
    );
    _this.openModalFallback(_this.$el, "ChiliPiper.submit onError");
  };

  // Flows configured with an in-app trigger (submit_trigger="InAppButton")
  // reject the ThirdPartyForm shape — they prescribe an explicit trigger
  // and a PersonEmail-keyed lead (the flow's Embed-tab snippet, verified
  // against the prod Free Trial flow).
  if (_this.submitTrigger) {
    _this.triggerSubmit(_this.submitTrigger, urlParams.get("email"), onError);

    return;
  }

  var lead = {
    email: urlParams.get("email"),
    FirstName: urlParams.get("firstname") || "",
    LastName: urlParams.get("lastname") || "",
    Phone: urlParams.get("phone") || "",
    company: urlParams.get("company") || "",
  };

  if (helpers.shouldDebug("ds3"))
    console.log(
      "[ChiliPiperDS] directSubmit — opening scheduler via ChiliPiper.submit",
      _this.accountName,
      _this.router,
      lead,
    );

  ChiliPiper.submit(_this.accountName, _this.router, {
    map: true,
    lead: lead,
    onError: onError,
  });
};

/** Open the form modal (deep-link fallback path). */
ChiliPiperDS.openModalFallback = function ($el, reason) {
  // form_fallback="false" instances (e.g. schedule-your-demo) never show
  // the HS form — no-email / CP-failure cases fall through to the page's
  // own holding/notice state instead.
  if (!ChiliPiperDS.formFallback) {
    if (helpers.shouldDebug("ds3"))
      console.log(
        `[ChiliPiperDS] form fallback disabled — no modal (${reason})`,
      );

    return;
  }

  var $modal = $el.closest(".DS3Modal");

  if (!$modal.length) return;

  if (helpers.shouldDebug("ds3"))
    console.log(`[ChiliPiperDS] auto-opening form modal (${reason})`);

  $modal.modal("show");
};
ChiliPiperDS.initForm = function () {
  // Skip loading the HubSpot form entirely when the fallback is disabled —
  // nothing consumes it (deep link uses ChiliPiper.submit, not the form),
  // and this avoids a needless prod HS form request on scheduler pages.
  if (!this.formFallback) {
    if (helpers.shouldDebug("ds3"))
      console.log("[ChiliPiperDS] initForm skipped — form_fallback disabled");

    return;
  }

  hbspt.forms.create({
    region: "na1",
    portalId: this.portalId,
    formId: this.formId,
    cssClass:
      "hubspot-demo-scheduler-lead-info-form hs-form-w-consent-checkbox",
    submitButtonClass:
      "btn btn-orange uppercase semibold hspacing1 submit-btn wide-btn mt-2",
    target: "#lead-info-form-" + this.formId,
    onFormReady: this.onFormReady,
    onFormSubmitted: this.onFormSubmitted,
  });

  if (helpers.shouldDebug("ds3")) {
    console.log(`[ChiliPiperDS] HS Portal ID: ${this.portalId}`);
    console.log(`[ChiliPiperDS] HS Form ID: ${this.formId}`);
  }
};

ChiliPiperDS.onFormReady = function ($form) {
  var _this = ChiliPiperDS;
  _this.formEl = $form;

  // console.log('ChiliPiperDS.onFormReady', _this.count++);
  if (helpers.shouldDebug("ds3"))
    console.log("[ChiliPiperDS] onFormReady", $form);

  ChiliPiperDS_FormHelpers.preventFormSubmit($form);
  ChiliPiperDS_FormHelpers.field_email($form);
  ChiliPiperDS_FormHelpers.field_company($form);
  ChiliPiperDS_FormHelpers.field_name($form);
  ChiliPiperDS_FormHelpers.field_industry($form);
  ChiliPiperDS_FormHelpers.setState($form);
  ChiliPiperDS_FormHelpers.field_country($form);
  ChiliPiperDS_FormHelpers.fields_prefill($form);
  ChiliPiperDS_FormHelpers.fields_utms($form);
  ChiliPiperDS_FormHelpers.fields_adps($form);
  ChiliPiperDS_FormHelpers.fields_partner($form);
  ChiliPiperDS_FormHelpers.fields_profile($form);
  ChiliPiperDS_FormHelpers.field_franchisor($form);
  ChiliPiperDS_FormHelpers.field_salesChannel($form);
  ChiliPiperDS_FormHelpers.field_requestedDemoType($form);
  ChiliPiperDS_FormHelpers.field_zip($form);
  ChiliPiperDS_FormHelpers.field_website($form);
  ChiliPiperDS_FormHelpers.setAdditionalRequiredFields($form);
  ChiliPiperDS_FormHelpers.setFieldLabelVisibilty($form);

  ChiliPiperDS_EmailVerification.init($form);
  ChiliPiperDS_PhoneVerification.init($form);
  ChiliPiperDS_Multistep.init($form);

  _this.initRouter($form);
};

ChiliPiperDS.onFormSubmitted = function ($form, data) {
  var _this = ChiliPiperDS;

  ChiliPiperDS_DispatchEvents.onFormSubmitted(_this.formEl, data);
  // console.log('ChiliPiperDS.onFormSubmitted', _this.count++);

  if (helpers.shouldDebug("ds3"))
    console.log("[ChiliPiperDS] onFormSubmitted", $form, data);
  // console.log('ChiliPiperDS.onFormSubmitted data.submissionValues', data.submissionValues);

  helpers.dispatchEvent("ds3_info_submit", data.submissionValues);

  ChiliPiperDS_FormHelpers.setHubspotContactId($form);

  // In-app-trigger instances: the fallback form doubles as the email
  // collector — with the visitor's submitted email we run the same direct
  // submit the deep link uses, so they still get the calendar instead of
  // the old capture-only dead end. Lead capture already happened (HS).
  if (_this.submitTrigger) {
    var submittedEmail =
      data && data.submissionValues ? data.submissionValues.email : null;

    if (submittedEmail) {
      _this.triggerSubmit(_this.submitTrigger, submittedEmail);
    } else if (helpers.shouldDebug("ds3")) {
      console.log(
        "[ChiliPiperDS] onFormSubmitted — no email in submissionValues, staying capture-only",
      );
    }
  }

  // Change to last step on submit if multistep enabled
  if (_this.$el[0].hasAttribute("data-multistep")) {
    const currStep = parseInt(_this.$el[0].getAttribute("data-step"));
    const nextStep = currStep + 1;

    _this.$el[0].setAttribute("data-step", nextStep);
  }
};

ChiliPiperDS.initRouter = function ($form) {
  var _this = ChiliPiperDS;
  var meetingTypeId = _this.meetingType ?? null;

  if (helpers.shouldDebug("ds3"))
    console.log("[ChiliPiperDS] initRouter called");

  // In-app-trigger instances must NOT arm the form deploy: deploy forces
  // every submit into ThirdPartyForm, which such flows reject. The form
  // then chains to triggerSubmit via onFormSubmitted instead.
  if (_this.submitTrigger) {
    if (helpers.shouldDebug("ds3"))
      console.log(
        "[ChiliPiperDS] initRouter skipped — submit_trigger instance (deploy would force ThirdPartyForm)",
      );

    return;
  }

  /*
   * onSuccess IS ADDED ONLY WHEN data-redirect IS SET, and that condition is the whole design.
   *
   * A booking's destination is configured in the Chili Piper admin, per ROUTER — that is what sends
   * people to /video-demo/ today, and every page sharing that router shares the setting. Passing
   * onSuccess unconditionally would take that decision away from CP for all of them at once.
   * Spreading an empty object when no override exists leaves the deploy call exactly as it was.
   *
   * CP APPENDS THE LEAD FIELDS TO ITS OWN REDIRECT (FirstName, LastName, email, company, Phone …),
   * and taking the redirect over loses them — so they are rebuilt here from the payload CP hands the
   * callback. Whatever is already on the URL (utm_* and friends) stays underneath, so the
   * destination sees the same shape CP would have sent.
   */
  const override =
    _this.$el && _this.$el[0] ? _this.$el[0].getAttribute("data-redirect") || "" : "";
  const redirectHandler = !override
    ? {}
    : {
        /*
         * REDIRECTING HERE IS NOT COOPERATION WITH CHILI PIPER — IT IS BEATING IT.
         *
         * CP performs its own post-booking redirect, configured in the CP admin against the flow,
         * and there is no client-side way to suppress it: the navigation happens inside the
         * scheduler iframe. Navigating synchronously from onSuccess wins that race; anything later
         * does not.
         *
         * WAITING FOR onClose WAS TRIED AND LOST. It would let the visitor read CP's confirmation
         * panel first — "You are meeting with …", the time, the guest list — but CP redirected to
         * its own destination the moment the panel closed. That version is worth restoring the day
         * CP's own redirect is cleared in its admin, and not before: with the redirect still
         * configured, onClose means CP wins and this attribute does nothing.
         */
        onSuccess: (payload) => {
          const params = new URLSearchParams(window.location.search);

          Object.entries(payload || {}).forEach(([key, value]) => {
            if (value === null || value === undefined || typeof value === "object") return;

            params.set(key, String(value));
          });

          /*
           * THE LEAD FIELDS ARE INSIDE payload.redirectUrl, not alongside it.
           *
           * CP hands the callback the URL it was going to navigate to, lead appended as a query
           * string — so the whole thing arrives as ONE encoded parameter. Left as-is the destination
           * reads `redirectUrl=https%3A%2F%2F…` and nothing else, so its query string is unpacked
           * and merged up to the top level: the shape the destination would have seen had CP
           * redirected it itself.
           *
           * routeId, eventId and assigneeId are kept — they identify the booking.
           */
          if (params.has("redirectUrl")) {
            try {
              new URL(params.get("redirectUrl")).searchParams.forEach((value, key) => {
                params.set(key, value);
              });

              params.delete("redirectUrl");
            } catch {
              // Not a URL we can parse — leave it whole rather than lose it.
            }
          }

          const query = params.toString();
          const target = override + (query ? "?" + query : "");

          if (helpers.shouldDebug("ds3"))
            console.log("[ChiliPiperDS] onSuccess redirect", target, payload);

          window.location.href = target;
        },
      };

  if (typeof ChiliPiper === "object") {
    ChiliPiper.deploy(_this.accountName, _this.router, {
      formType: "Hubspot",
      formIds: [ChiliPiperDS.formId],
      onBeforeSubmit: (sentLead) => {
        return {
          ...sentLead,
          FirstName: $form.find('[name="firstname"]').val(),
          LastName: $form.find('[name="lastname"]').val(),
          Phone: $form.find('[name="phone"]').val(),
          UTM_Medium__c: $form.find('[name="utm_medium"]').val(),
          UTM_Campaign__c: $form.find('[name="utm_campaign"]').val(),
          UTM_Source__c: $form.find('[name="utm_source"]').val(),
          UTM_Content__c: $form.find('[name="utm_content"]').val(),
          UTM_Term__c: $form.find('[name="utm_term"]').val(),
          SMSOptOut__c: $form.find('[name="smsoptout__c"]').val(),
          Additonal_Datapoint_4__c: $form
            .find('[name="additional_datapoint_4"]')
            .val(),
          EngagedInDemo__c: $form.find('[name="engaged_in_demo"]').val(),
          EngagedDemoType__c: $form.find('[name="engageddemotype__c"]').val(),
          State: $form.find('[name="state"]').val(),
        };
      },
      debug: true,
      meetingTypeId,
      ...redirectHandler,
    });

    if (helpers.shouldDebug("ds3"))
      console.log("[ChiliPiperDS] initRouter deployed");
  }
};

window.ChiliPiperDS = ChiliPiperDS;
